import { useCallback, useEffect, useReducer } from "react";

const KEY = "saved";

function load(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? new Set(JSON.parse(raw) as string[]) : new Set();
  } catch {
    return new Set();
  }
}

function save(refs: Set<string>) {
  localStorage.setItem(KEY, JSON.stringify([...refs]));
}

const listeners = new Set<() => void>();
let shared = load();

function notify() {
  listeners.forEach((fn) => fn());
}

export function useSaved() {
  const [, rerender] = useReducer((n: number) => n + 1, 0);

  useEffect(() => {
    const fn = () => rerender();
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  const toggle = useCallback((ref: string) => {
    const next = new Set(shared);
    if (next.has(ref)) next.delete(ref);
    else next.add(ref);
    shared = next;
    save(next);
    notify();
  }, []);

  const isSaved = useCallback((ref: string) => shared.has(ref), []);

  return { refs: shared, count: shared.size, toggle, isSaved };
}
